<template>
  <div class="noData-tip">
    <div class="noData-img">
      <img class="img" :src="noDataImage" />
      <p>还没有任何消息~</p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      noDataImage: require('../assets/weihu.png')
    }
  }
}
</script>
<style lang="scss" scoped>
.noData-tip {
  width: 100%;
  position: fixed;
  top: 3.6rem;
  left: 0;
  z-index: 6;
  .noData-img {
    text-align: center;
    img {
      width: 3rem;
      height: 2rem;
    }
    p {
      margin-top: 0.2rem;
      width: 100%;
      text-align: center;
      color: #a3a6b6;
      font-size: 0.3rem;
    }
  }
}
</style>
